import React from "react";
import { Box, VStack, Heading, useToast } from "@chakra-ui/react";
import TalentPoolEditor from "../components/TalentPoolEditor";
import TalentPoolTable from "../components/TalentPoolTable";
import useTalentPools from "../hooks/useTalentPools";

const TalentPoolsPage = () => {
  const toast = useToast();
  const { data, createPoolMutation } = useTalentPools();

  const handleCreate = async (payload) => {
    try {
      await createPoolMutation.mutateAsync(payload);
      toast({
        title: "Talent pool created",
        status: "success",
        duration: 2500,
      });
    } catch (error) {
      toast({
        title: "Failed to create pool",
        description: error?.response?.data?.message || "Please try again",
        status: "error",
        duration: 3000,
      });
    }
  };

  return (
    <Box p={6}>
      <VStack align="stretch" spacing={4}>
        <Heading size="md">Talent Pools</Heading>
        <TalentPoolEditor
          onCreate={handleCreate}
          isLoading={createPoolMutation.isPending}
        />
        <TalentPoolTable pools={data?.data || []} />
      </VStack>
    </Box>
  );
};

export default TalentPoolsPage;
